import React, { useState } from 'react';
import { TableCell, TableModifier, TableRow } from '../../../components/organisms/Table';
import { SearchBreadcrumb } from '../../../components/molecules/SearchBreadcrumb';
import { DateFormat, DateFormats } from '../../../_lib/components/DateFormat';
import Btn, { BtnModifier } from '../../../components/molecules/Btn';
import { Icons } from '../../../components/atoms/SVG';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Hyperlink } from '../../../components/atoms/Hyperlink';
import { ISonURL } from '../../../types/IUrl';
import ILink from '../../../types/ILink';
import { SonForm } from '../../../_lib/Form2';
import ModalDialog from '../../../components/organisms/ModalDialog/ModalDialog';
import { AcceptDeclineForm } from '../../../_lib/Form2/standardForms/AcceptDeclineForm/AcceptDeclineForm';
import useRedirect from '../../../hooks/useRedirect';
import { Hint } from '../../../_lib/components/Hint';

export type TrashedPage = {
  pageName: string;
  pageId: string;
  path: ISonURL[];
  numberOfChildPages: number;
  trashDate: string;
  trashedBy: ILink;
  finalDeletionDate: string;
  restoreFromTrashForm: SonForm<any>;
};

export function PageTrashTableRow({
  pageName,
  pageId,
  path,
  numberOfChildPages,
  trashDate,
  trashedBy,
  finalDeletionDate,
  restoreFromTrashForm,
}: TrashedPage) {
  const { t } = useSonTranslation('PageTrash');
  const [redirect] = useRedirect();
  const [showModal, setShowModal] = useState(false);

  return (
    <TableRow key={pageId}>
      <TableCell dataHead={t('table.tableHead.pageInformation')} modifier={TableModifier.XLWIDTH}>
        <strong className="font-bold-15-21">{pageName}</strong>
        <SearchBreadcrumb breadcrumbs={path} />
      </TableCell>
      <TableCell dataHead={t('table.tableHead.numberOfChildPages')}>{numberOfChildPages}</TableCell>
      <TableCell dataHead={t('table.tableHead.trashDate')}>
        <DateFormat date={trashDate} format={DateFormats.DATE_TIME} />
      </TableCell>
      <TableCell dataHead={t('table.tableHead.trashedBy')}>
        <Hyperlink to={trashedBy.url} className="page-trash-block__person-link font-regular-15-21">
          {trashedBy.name}
        </Hyperlink>
      </TableCell>
      <TableCell dataHead={t('table.tableHead.finalDeletionDate')}>
        <DateFormat date={finalDeletionDate} format={DateFormats.DATE} />
      </TableCell>
      <TableCell dataHead={t('table.tableHead.actions')}>
        <Btn
          modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
          svgSpriteId={Icons.RESTORE}
          type="button"
          text={t('actions.restore.text', { pageName })}
          titleText={t('actions.restore.title', { pageName })}
          hiddenText
          tooltipPlacement={TooltipPlacement.TOP}
          onClick={() => setShowModal(true)}
        />
        {showModal
          ? (
              <ModalDialog
                closeModal={() => setShowModal(false)}
                headline={t('actions.restore.title', { pageName })}
                initialFocusIndex={1}
              >
                <AcceptDeclineForm
                  messageSuccess={t('actions.restore.form.status.success')}
                  messageSending={t('actions.restore.form.status.sending')}
                  messageFail={t('actions.restore.form.status.fail')}
                  messageForward={t('actions.restore.form.status.forward')}
                  headline={t('actions.restore.form.headline')}
                  onSuccess={(response) => {
                    if (response?.data?.url) {
                      redirect(response?.data?.url);
                    } else {
                      setShowModal(false);
                    }
                  }}
                  form={restoreFromTrashForm}
                >
                  <Hint message={t('actions.restore.form.hint')} />
                </AcceptDeclineForm>
              </ModalDialog>
            )
          : undefined}
      </TableCell>
    </TableRow>
  );
}
